import axios from 'axios';
import Bugsnag from '@bugsnag/js';
import _ from 'lodash';
import {
  IS_LOADING,
  DOCTOR_UPDATE,
  DOCTOR_CREATE,
  DOCTOR_FETCH_ONE,
  DOCTOR_CLEAR,
  DOCTOR_GET_WALLET,
  DOCTOR_WALLET_HISTORY
} from './types';

export const doctorCreate = params => async dispatch => {
  const url = 'doctors';

  dispatch({ type: DOCTOR_CLEAR });
  dispatch({ type: IS_LOADING, status: true, names: { DOCTOR_CREATE: true } });
  await axios.post(url, params).then(response => {
    const resData = response.data;
    const data = (resData?.data || resData);
    let status = 'success';
    if (resData.error || resData.errors) {
      status = 'error';
    }
    dispatch({ type: DOCTOR_CREATE, playload: { data, status } });
    dispatch({ type: IS_LOADING, status: false, names: { DOCTOR_CREATE: false } });
  }).catch(err => {
    let error = err;
    dispatch({ type: IS_LOADING, status: false, names: { DOCTOR_CREATE: false } });
    if ((_.has(error, 'response.status') && error.response.status === 502) || _.isUndefined(error.response)) {
      if (_.isUndefined(error.response)) { error = Error(`502 API at ${url}`); }
      Bugsnag.notify(error);
    }
  });
};

export const getDoctorByCode = docCode => async dispatch => {
  const url = `doctors?code=${docCode}`;

  dispatch({ type: DOCTOR_CLEAR });
  dispatch({ type: IS_LOADING, status: true, names: { DOCTOR_FETCH_ONE: true } });
  await axios.get(url).then(response => {
    const resData = response.data;
    const data = ((resData && resData.data) || []);
    const detail = data.find(o => o.docCode === docCode);
    let status = 'success';
    if (resData.error || resData.errors) {
      status = 'error';
    }
    dispatch({ type: DOCTOR_FETCH_ONE, playload: { detail, status } });
    dispatch({ type: IS_LOADING, status: false, names: { DOCTOR_FETCH_ONE: false } });
  }).catch(err => {
    let error = err;
    dispatch({ type: IS_LOADING, status: false, names: { DOCTOR_FETCH_ONE: false } });
    if ((_.has(error, 'response.status') && error.response.status === 502) || _.isUndefined(error.response)) {
      if (_.isUndefined(error.response)) { error = Error(`502 API at ${url}`); }
      Bugsnag.notify(error);
    }
  });
};

export const doctorUpdate = (docCode, dataSet) => async dispatch => {
  const url = `doctors/${docCode}`;

  dispatch({ type: DOCTOR_CLEAR });
  dispatch({ type: IS_LOADING, status: true, names: { DOCTOR_UPDATE: true } });
  await axios.put(url, dataSet).then(response => {
    const resData = response.data;
    const { message } = resData;
    let status = 'success';
    if (resData.error || resData.errors) {
      status = 'error';
    }
    dispatch({ type: DOCTOR_UPDATE, playload: { status, message } });
    dispatch({ type: IS_LOADING, status: false, names: { DOCTOR_UPDATE: false } });
  }).catch(err => {
    let error = err;
    dispatch({ type: DOCTOR_UPDATE, playload: { status: 'error' } });
    dispatch({ type: IS_LOADING, status: false, names: { DOCTOR_UPDATE: false } });
    if ((_.has(error, 'response.status') && error.response.status === 502) || _.isUndefined(error.response)) {
      if (_.isUndefined(error.response)) { error = Error(`502 API at ${url}`); }
      Bugsnag.notify(error);
    }
  });
};

export const doctorClear = () => dispatch => {
  dispatch({ type: DOCTOR_CLEAR });
};

export const getDoctorWallet = docCode => async dispatch => {
  const url = `wallet/doctor/${docCode}`;

  dispatch({ type: DOCTOR_CLEAR });
  dispatch({ type: IS_LOADING, status: true, names: { DOCTOR_GET_WALLET: true } });
  await axios.get(url).then(response => {
    dispatch({ type: DOCTOR_GET_WALLET, playload: { wallet: response.data, status: 'success' } });
    dispatch({ type: IS_LOADING, status: false, names: { DOCTOR_GET_WALLET: false } });
  }).catch(err => {
    let error = err;
    const wallet = {
      total: 0,
      paid: 0,
      waiting: 0,
      cancel: 0
    };
    dispatch({ type: DOCTOR_GET_WALLET, playload: { wallet, status: 'success' } });
    dispatch({ type: IS_LOADING, status: false, names: { DOCTOR_GET_WALLET: false } });
    if ((_.has(error, 'response.status') && error.response.status === 502) || _.isUndefined(error.response)) {
      if (_.isUndefined(error.response)) { error = Error(`502 API at ${url}`); }
      Bugsnag.notify(error);
    }
  });
};

export const getWalletLists = (docCode, params = [], limit = 100, nextKey = '') => async dispatch => {
  let isAddMore = false;
  const newParams = [
    `limit=${limit}`,
    ...params
  ];

  let url = `wallet/history/${docCode}?${newParams.join('&')}`;

  if (nextKey !== '') {
    isAddMore = true;
    url += `&nextKey=${nextKey}`;
  }

  dispatch({ type: DOCTOR_CLEAR });
  dispatch({ type: IS_LOADING, status: true, names: { DOCTOR_WALLET_HISTORY: true } });
  await axios.get(url).then(response => {
    const data = (response.data && response.data.data) || [];
    dispatch({
      type: DOCTOR_WALLET_HISTORY,
      playload: {
        data,
        status: 'success',
        isAddMore,
        nextKey: response?.data?.nextKey
      }
    });
    dispatch({ type: IS_LOADING, status: false, names: { DOCTOR_WALLET_HISTORY: false } });
  }).catch(err => {
    let error = err;
    dispatch({ type: DOCTOR_WALLET_HISTORY, playload: { data: [], status: 'success' } });
    dispatch({ type: IS_LOADING, status: false, names: { DOCTOR_WALLET_HISTORY: false } });
    if ((_.has(error, 'response.status') && error.response.status === 502) || _.isUndefined(error.response)) {
      if (_.isUndefined(error.response)) { error = Error(`502 API at ${url}`); }
      Bugsnag.notify(error);
    }
  });
};

export const doctorUpdateEkyc = (docCode, params) => {
  const url = `/doctors/${docCode}`;
  return new Promise(reslove => {
    axios.put(url, params).then(response => {
      reslove(response.data);
    }).catch(error => {
      reslove(error);
    });
  });
};
